module.exports = __webpack_public_path__ + "img/checkboxRef.29d38358.svg";